import api from "axios";

export const makeEvaluation = async (id_avaliacao, valor) => {
  return api
    .post("/purchasers/makeEvaluation", {
        id_avaliacao,
        valor
    })
    .then((response) => response.data)
    .catch((error) => error);
};
